<!--
- Author:  LiShibin.
- Date:    2016/12/22.
- File:    登录测试
-->
<template>
  <div class="login-class">
    <div class="login">
      <div class="login-title">{{ platformName }}</div>
      <el-form v-if="!moreSys" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="" style="width: 80%">
        <el-form-item label="" prop="account">
          <el-input v-model="ruleForm.account" placeholder="请输入账号" clearable>
            <img slot="prefix" class="prefix-img" src="../assets/images/login/user.png" alt="">
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="pwd">
          <el-input type="password" clearable show-password placeholder="请输入密码" v-model="ruleForm.pwd">
            <img slot="prefix" class="prefix-img" src="../assets/images/login/psd.png" alt="">
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button style="width: 100%" type="primary" @click="sign('ruleForm')">登 录</el-button>
        </el-form-item>
      </el-form>
      <el-form v-show="moreSys" label-position="left" label-width="60px" style="width: 80%">
        <el-form-item label="体系">
          <el-select style="width: 100%" v-model="sysId"
                     :disabled="sysList.length===1"
                     @change="changeSys"
                     placeholder="请选择体系">
            <el-option
              v-for="item in sysList"
              :key="item.sysId"
              :label="item.sysName"
              :value="item.sysId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组织">
          <el-select
            style="width: 100%"
            v-model="orgId"
            :disabled="orgList.length===1"
            @change="changeOrg"
            placeholder="请选择组织">
            <el-option
              v-for="item in orgList"
              :key="item.orgId"
              :label="item.orgShort"
              :value="item.orgId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button style="width: 100%" type="primary" class="login-action-sign" @click="next">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        sysId: '', // 'S1292CCB6C7E44B1693DC4C6588B92ED6',
        orgId: '', // 'OA238FEE955D045C08F91342F042992A9',
        account: '', // 350102199003076916 // admin123  18305921962 110101199003071671  350102199003078559 350102199003076916
        pwd: '', // 12345678
        fileServerHost: '192.168.254.188',
        fileServerPort: '8003',
        imgServerHost: '192.168.254.188',
        imgServerPort: '8001',
        moreSys: false,
        sysList: [],
        orgList: [],
        theme: '0', // '0' 为默认主题，‘1’ 为联通主题
        ruleForm: {
          account: '', // 350102199003076916 // admin123  18305921962 110101199003071671  350102199003078559 350102199003076916
          pwd: '' // 12345678
        },
        rules: {
          account: [
            {required: true, message: '请输入账号名', trigger: 'blur'}
          ],
          pwd: [
            {required: true, message: '请输入密码', trigger: 'blur'}
          ]
        },
        loginForm: {
          username: 'superadmin',
          password: '12345678',
          grant_type: 'password',
          scope: 'server',
          client_id: 'client_2',
          client_secret: '123456'
        },
        isWeb: false,
        platformName: '基于AI智能分析的数字食安系统'
      }
    },
    computed: {
      ...mapState({
        clientId: state => state.settings.clientId,
        clientSecret: state => state.settings.clientSecret,
        otherClientId: state => state.settings.otherClientId
      })
    },
    beforeRouteEnter(to, from, next) {
      next(() => {
        document.querySelector('html').style.height = '100%'
        document.querySelector('body').style.height = '100%'
      })
    },
    beforeRouteLeave(to, from, next) {
      document.querySelector('html').style.height = '1080px'
      document.querySelector('body').style.height = '1080px'
      next()
    },
    mounted() {
      // window.localStorage.setItem('isLogin', '')
      if(this.$route.query.platformName){
        this.platformName = this.$route.query.platformName
      }
    },
    methods: {
      /**
       * @author wanghongling
       * @createTime 2019/06/19
       * @description 登录
       */
      sign(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let params = {
              username: this.ruleForm.account.trim(),
              password: this.ruleForm.pwd,
              grant_type: 'password',
              scope: 'server',
              client_id: this.clientId,
              client_secret: this.clientSecret
            }
            this.$store.dispatch('user/login', params).then(() => {
              this.$router.push({path: '/'})
              window.localStorage.setItem('loginInfo', JSON.stringify({userName:this.ruleForm.account.trim(),password:this.ruleForm.pwd}))
              this.getWebMenu()
            }).catch(() => {
              this.loading = false
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      /**
       * @author wanghongling
       * @createTime 2019/06/19
       * @description 获取组织
       * @param sysId 体系id
       */
      getOrg(sysId) {
        this.$request.getOrgList(sysId).then(response => {
          console.log('获取组织', response)
          this.orgList = response
          this.orgId = ''
          if (response.length > 0) {
            this.orgId = response[0].orgId
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @author wanghongling
       * @createTime 2019/06/19
       * @description 获取体系
       */
      getOsys() {
        // 执行这一步
        this.$request.getOsys().then(response => {
          console.log('获取体系', response)
          this.sysList = response
          this.sysId = ''
          if (response.length > 0) {
            this.moreSys = true
            this.sysId = response[0].sysId
            this.getOrg(this.sysId)
          } else {
            this.moreSys = false
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description: 选择体系
       * @author wanghongling
       * @createDate 2020/2/26
       */
      changeSys(e) {
        this.sysId = e
        this.getOrg(e)
      },
      /**
       * @Description:选择组织
       * @author wanghongling
       * @createDate 2020/2/26
       */
      changeOrg(e) {
        console.error()
        this.orgId = e
      },
      /**
       * @Description:下一步
       * @author wanghongling
       * @createDate 2020/2/26
       */
      next() {
        if (this.sysId === '') {
          this.$superMessage('提示', '请选择体系')
        } else if (this.orgId === '') {
          this.$superMessage('提示', '请选择组织')
        } else {
          window.localStorage.setItem('sysId', this.sysId)
          window.localStorage.setItem('orgId', this.orgId)
          this.$request.getUserInfo({}).then(res => {
            window.localStorage.setItem('userName', res.userName)
            window.localStorage.setItem('isLogin', 'true')
            this.$router.push('/')
            console.log('人员信息', res)
          })
        }
      },
      /**
       * @Description: 获取大屏权限
       * @author zhangkang
       * @date 2021/1/4
       */
      getWebMenu() {
        let params = {
          clientId: this.otherClientId,
          platform: '01'
        }
        this.$request.menuTopListGet(params).then(params).then(res => {
          console.log(res, 'getWebMenu')
          if (!this.$utils.isEmptyObject(res)) {
            this.isWeb = res.length > 0
          }
          window.localStorage.setItem('isWeb', JSON.stringify(this.isWeb))
        }).catch(e => {
          console.error(e)
        })
      }

    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .login-class {
    width: 100%;
    height: 100%;
    background: url("../assets/images/login/bg.jpg") center center;
    background-size: cover;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    .login {
      position: relative;
      width: 514px;
      height: 422px;
      text-align: center;
      background: url("../assets/images/login/login.png") center center;
      background-size: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &-title {
        width: 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -80px;
        // font-size: 50px;
        font-size: 35px;
        font-weight: bold;
        //background: linear-gradient(#fff, #fff, #4b6585);
        //-webkit-background-clip: text;
        //color: transparent;
        color: #fff;
        box-shadow: 0 4px 5px 2px #050c26;
      }

      .el-input__inner {
        font-size: 20px;
        color: #fff;
        height: 50px;
        line-height: 50px;
        background-color: rgba(255, 255, 255, 0.05);
        border: 1px solid #185f74;
        margin-bottom: 10px;
      }

      .el-input.is-active .el-input__inner, .el-input__inner:focus {
        border-color: #00fff6;
        outline: 0;
      }

      .el-input--prefix .el-input__inner {
        padding-left: 46px;
      }

      .prefix-img {
        padding: 12px 12px;
      }

      .el-button {
        margin-top: 20px;
        font-size: 20px;
        background: linear-gradient(#17dbe7, #185c70);
        border-color: #262855;
        padding: 15px 20px;
        border-radius: 10px;
      }

      .el-form-item__label {
        font-size: 20px;
        color: #fff;
      }
    }

    /*一个账号是否存在多体系*/

    .sysOrg {
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/login.vue